// extracted by mini-css-extract-plugin
export default {"tooltip":"vn9hC","header":"xRx__","body":"Fv3A3","image":"MhjSh"};